import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '../../lib/utils'

const alertVariants = cva('flex items-center gap-2 px-6 py-2 text-sm', {
  variants: {
    variant: {
      info: 'bg-bg-subtle text-fg-muted',
      warning: 'bg-warn-surface text-warn',
      danger: 'bg-err-surface text-err',
      success: 'bg-ok-surface text-ok',
    },
  },
  defaultVariants: { variant: 'info' },
})

interface AlertProps extends React.ComponentProps<'div'>, VariantProps<typeof alertVariants> {
  dot?: boolean
}

/** Full-width inline banner. Not a toast — this one stays until state changes. */
function Alert({ className, variant, dot, children, ...props }: AlertProps) {
  return (
    <div role="status" className={cn(alertVariants({ variant, className }))} {...props}>
      {dot && <span aria-hidden className="size-1.5 shrink-0 rounded-full bg-current" />}
      {children}
    </div>
  )
}

export { Alert, alertVariants, type AlertProps }
